(function ($) {

    var set_media_size = function(){
        var media_sizes = Foundation.MediaQuery.queries;
        var found = false;
        var found_size = [];

        for (var size in media_sizes) {

            if($.inArray(media_sizes[size].name, found_size) < 0) {
                if (Foundation.MediaQuery.current != media_sizes[size].name && !found) {
                    $('html').addClass('grid-' + media_sizes[size].name);
                } else if (Foundation.MediaQuery.current == media_sizes[size].name) {
                    $('html').addClass('grid-' + media_sizes[size].name);
                    found = true;
                } else {
                    $('html').removeClass('grid-' + media_sizes[size].name);
                }

                found_size.push(media_sizes[size].name);
            }else{
                break;
            }
        }
    };

    $(window).on('changed.zf.mediaquery load load-page', set_media_size);

})
(jQuery);